import React, { Fragment } from 'react';
import { Table, Collapse, Button } from 'reactstrap';

import makeUrl from '../../lib/makeUrl';
import Toggler from '../../components/UI/Toggler';
import SortAndFilter from './SortAndFilter';
import { truncateText } from '../../lib/utils';
import { formatDate, getHoursSinceBooking, formatDateWithDaysForFlights } from './utils';

type Status = {
  type: string,
  ts: string,
};

type Money = {
  amount: number,
  currency: string,
};

type Trekker = {
  email: string,
  id: string,
  name: string,
};

type FlightDetails = {
  adult: string,
  adultFare: string,
  agencyCommission: string,
  aircraftType: string,
  airline: string,
  arrival: string,
  arrivalTime: string,
  callingStation: string,
  callingStationId: string,
  child: string,
  childFare: string,
  currency: string,
  departure: string,
  departureTime: string,
  flightClassCode: string,
  flightDate: string,
  flightId: string,
  flightNo: string,
  freeBaggage: string,
  fuelSurcharge: string,
  infant: string,
  infantFare: string,
  refundable: string,
  resFare: string,
  tax: string,
};

type Props = {
  bookingDate: string,
  bookingId: string,
  bookingStatus: string,
  contactInformation: {
    name: null | string,
    email: null | string,
    mobile: null | string,
  },
  flightDetails: FlightDetails,
  numPax: number,
  paidAmount: Money,
  paymentId: null | string,
  returnFlightDetails: FlightDetails,
  status: Status,
  totalAmount: Money,
  trekId: string,
  trekker: Trekker,
};

type Data = { data: Props };

const TableHeaders = [
  'Booking Date',
  'Time since(hrs)',
  'Trekker Name',
  'Departure',
  'Arrival',
  'Flight Date',
  'Status',
  'PAX',
  'Amount (USD)',
];

const color = {
  accepted: 'rgba(0, 128, 0, 0.2)',
  rejected: 'rgba(255, 0, 0, 0.2)',
  pending: 'rgba(255, 255, 0, 0.2)',
};

const FlightsBookings = (props: Data) => (
  <SortAndFilter>
    {({ sortBookings, showOrHide }) => (
      <div className="col-12">
        <Table responsive className="admin-table">
          <thead>
            <tr>
              {TableHeaders.map(h => (
                <th key={h}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sortBookings(props.data).map(d => {
              const { amount: totalAmount, invoiceId: bookingId, status, itemData } = d;

              const {
                bookingDate,
                trekker,
                flightDetails,
                returnFlightDetails,
                pax: numPax,
              } = itemData;
              const { fullname, email, id } = trekker;

              const bookingStatus = status[0].type.toLowerCase();
              const statusColor = color[bookingStatus];

              return (
                <Toggler key={bookingId}>
                  {({ on, toggle }) => (
                    <Fragment>
                      <tr
                        style={{
                          ...showOrHide(bookingStatus),
                          backgroundColor: statusColor,
                        }}
                      >
                        <td>{formatDate(bookingDate)}</td>
                        <td>{getHoursSinceBooking(bookingDate)}</td>
                        <td>
                          <a
                            href={fullname && makeUrl.goToProfile(fullname, id)}
                            title={fullname}
                          >
                            {fullname && truncateText(fullname, 12)}
                          </a>
                        </td>
                        <td>
                          {flightDetails && (
                            <a title={flightDetails.departure}>
                              {' '}
                              {truncateText(flightDetails.departure, 6)}
                            </a>
                          )}
                          <br />
                          {returnFlightDetails && (
                            <a title={returnFlightDetails.departure}>
                              {' '}
                              {truncateText(returnFlightDetails.departure, 6)}
                            </a>
                          )}
                        </td>
                        <td>
                          {flightDetails && (
                            <a title={flightDetails.arrival}>
                              {' '}
                              {truncateText(flightDetails.arrival, 6)}
                            </a>
                          )}
                          <br />
                          {returnFlightDetails && (
                            <a title={returnFlightDetails.arrival}>
                              {' '}
                              {truncateText(returnFlightDetails.arrival, 6)}
                            </a>
                          )}
                        </td>
                        <td>
                          {flightDetails &&
                            formatDateWithDaysForFlights(flightDetails.flightDate)}
                          <br />
                          {(returnFlightDetails &&
                            formatDateWithDaysForFlights(returnFlightDetails.flightDate)) ||
                            ''}
                        </td>

                        <td>{bookingStatus}</td>
                        <td>{numPax}</td>
                        <td>{totalAmount}</td>
                        <td>
                          <Button onClick={toggle}>+</Button>
                        </td>
                      </tr>
                      <tr style={showOrHide(bookingStatus)}>
                        <td colSpan="8">
                          <Fragment>
                            <Collapse isOpen={on} className="more-detail">
                              {flightDetails && (
                                <ul>
                                  <li className="title">Flight Details:</li>
                                  <li>Airline: {flightDetails.airline}</li>
                                  <li>No of Adults: {flightDetails.adult}</li>
                                  <li>No of Child: {flightDetails.child}</li>
                                  <li>Flight Id: {flightDetails.flightId}</li>
                                  <li>Flight No: {flightDetails.flightNo}</li>
                                </ul>
                              )}

                              <ul>
                                <li className="title">Trekker Details:</li>
                                <li>Email: {email || ''}</li>
                                <li>Id: {id}</li>
                              </ul>

                              {returnFlightDetails && (
                                <ul>
                                  <li className="title">Return Flight Details:</li>
                                  <li>Airline: {returnFlightDetails.airline}</li>
                                  <li>No of Adults: {returnFlightDetails.adult}</li>
                                  <li>No of Child: {returnFlightDetails.child}</li>
                                  <li>Flight Id: {returnFlightDetails.flightId}</li>
                                  <li>Flight No: {returnFlightDetails.flightNo}</li>
                                </ul>
                              )}
                            </Collapse>
                          </Fragment>
                        </td>
                      </tr>
                    </Fragment>
                  )}
                </Toggler>
              );
            })}
          </tbody>
        </Table>
      </div>
    )}
  </SortAndFilter>
);

export default FlightsBookings;



// WEBPACK FOOTER //
// ./src/screens/BookingsDashboard/FlightsBookings.jsx